import { FC, ReactNode, useState } from 'react'
import { useDispatch } from 'react-redux'

import { Dialog, Fade, StyledEngineProvider, ThemeProvider, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'

import AcquiringApiRegenerate from 'components/core/Acquiring/AcquiringApi/components/AcquiringApiRegenerate'
import { newFormThemeOverrides } from 'components/core/Acquiring/AcquiringApi/components/styles'
import { finishErrorAlert } from 'redux/alert/alert-actions'
import { themeStyles, useTheme } from 'themes'

interface IProps {
    classes: Record<string, string>
    children: ReactNode
}

const AcquiringApiRegenerateModal: FC<IProps> = ({ classes, children }) => {
    const dispatch = useDispatch()
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })
    const [open, setOpen] = useState(false)

    const handleOpen = () => setOpen(true)
    const handleClose = () => {
        dispatch(finishErrorAlert())
        setOpen(false)
    }

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={formTheme}>
                <Typography component="div" onClick={handleOpen} style={{ width: '100%', height: '100%' }}>
                    {children}
                </Typography>
                <Dialog
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    classes={{ paper: classes.paperDialogWidth, container: classes.MuiDialogContainer }}
                >
                    <Fade in={open}>
                        <div className={classes.paperDialog}>
                            <AcquiringApiRegenerate handleClose={handleClose} />
                        </div>
                    </Fade>
                </Dialog>
            </ThemeProvider>
        </StyledEngineProvider>
    )
}

export default withStyles(themeStyles.useModalStyles)(AcquiringApiRegenerateModal)
